import classnames from 'classnames';
import { numeric } from 'shared-base';
import { useMemory } from './Memory.hooks';
import { Wrapper } from './Memory.style';

export type MemoryProps = {};

const WARNING = 1.5 * 10 ** 9;
const DANGER = 3 * 10 ** 9;

export function Memory(_props: MemoryProps) {
  const memoryInfo = useMemory();
  const { totalJSHeapSize } = memoryInfo;

  const className = classnames('Memory-wrapper', {
    warning: totalJSHeapSize > WARNING,
    danger: totalJSHeapSize > DANGER,
  });

  return (
    <Wrapper className={className} data-testid='Memory-wrapper'>
      {numeric(totalJSHeapSize, 'bytes')}
    </Wrapper>
  );
}

export default Memory;
